import {
  EfsMelcoEfsModelsMapping,
  EfsMelcoEfsModelsMappingOutput,
  ProductionFulfillmentApi,
  useAuthenticatedAPIConfig,
  useFormSubmit,
} from "melco-shared-logic";

export type AddDesignMappingFormValueType = {
  name: string;
  service_type: string;
  format_id: string;
};

export const DEFAULT_OUTPUT: EfsMelcoEfsModelsMappingOutput = {
  name: "DEFAULT",
  type: "Template",
  config_type: "Global",
  patch: false,
};

export const useAddDesignMappingFormSubmit = (
  onSuccess: (designMapping: EfsMelcoEfsModelsMapping) => void
) => {
  const authenticatedApiConfig = useAuthenticatedAPIConfig();

  const onSubmit = useFormSubmit<AddDesignMappingFormValueType>(
    async (values: AddDesignMappingFormValueType, { resetForm }) => {
      const { service_type, format_id, name } = values;

      const api = new ProductionFulfillmentApi(authenticatedApiConfig());

      const designMapping = await api.productionFulfillmentMappingsCreate({
        efsMelcoEfsModelsCreateMapping: {
          config_type: "", //Must be set to be able to create a mapping
          name,
          service_type,
          format_id,
          outputs: [DEFAULT_OUTPUT],
        },
      });

      if (designMapping) {
        onSuccess(designMapping);
      }

      resetForm({ values });

      return { successMessages: [{ message: "default" }] };
    },
    { translationPrefix: "designMappings.actions.add" }
  );

  return onSubmit;
};
